export default __webpack_public_path__ + "img/348b712a936814690231a6484c96f3fb.svg";